import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages: [],
  loading: false,
  isAnalyzing: false,
  streamingEvents: [],
  isLiveAgent: false,
  order: null,
  initialOrderNumber: '',
  orderLoading: true,
  userName: '',
  userNameLoading: true,
  sessionEnded: false,
  liveAgentConnectivity: false,
  escalationRequired: false,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage(state, action) {
      state.messages.push(action.payload);
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setIsAnalyzing(state, action) {
      state.isAnalyzing = action.payload;
    },
    setStreamingEvents(state, action) {
      state.streamingEvents = action.payload;
    },
    setIsLiveAgent(state, action) {
      state.isLiveAgent = action.payload;
    },
    setOrder(state, action) {
      state.order = action.payload;
    },
    setInitialOrderNumber(state, action) {
      state.initialOrderNumber = action.payload;
    },
    setOrderLoading(state, action) {
      state.orderLoading = action.payload;
    },
    setUserName(state, action) {
      state.userName = action.payload;
    },
    setUserNameLoading(state, action) {
      state.userNameLoading = action.payload;
    },
    setSessionEnded(state, action) {
      state.sessionEnded = action.payload;
    },
    setLiveAgentConnectivity(state, action) {
      state.liveAgentConnectivity = action.payload;
    },
    setEscalationRequired(state, action) {
      state.escalationRequired = action.payload;
    },
  },
});

export const {
  addMessage,
  setLoading,
  setIsAnalyzing,
  setStreamingEvents,
  setIsLiveAgent,
  setOrder,
  setInitialOrderNumber,
  setOrderLoading,
  setUserName,
  setUserNameLoading,
  setSessionEnded,
  setLiveAgentConnectivity,
  setEscalationRequired,
} = chatSlice.actions;

export default chatSlice.reducer;
